module.exports = __webpack_public_path__ + "ce24e16efd55e7d0cc10e21711fbc4ff.pdf";